// Phase 20 · Community V3 · Streaming embed player (YouTube/Vimeo/Twitch/Loom)
import React from "react";
import { Video, ExternalLink } from "lucide-react";

function toEmbed(url, platform) {
    if (!url) return null;
    try {
        const u = new URL(url);
        if (platform === "youtube" || u.hostname.includes("youtu")) {
            const id = u.hostname.includes("youtu.be")
                ? u.pathname.slice(1)
                : u.searchParams.get("v") ||
                  (u.pathname.startsWith("/live/") ? u.pathname.split("/live/")[1] : null) ||
                  (u.pathname.startsWith("/embed/") ? u.pathname.split("/embed/")[1] : null);
            if (id) return `https://www.youtube.com/embed/${id}?autoplay=0`;
        }
        if (platform === "vimeo" || u.hostname.includes("vimeo")) {
            const id = u.pathname.split("/").filter(Boolean).pop();
            if (id) return `https://player.vimeo.com/video/${id}`;
        }
        if (platform === "twitch" || u.hostname.includes("twitch")) {
            const chan = u.pathname.split("/").filter(Boolean)[0];
            if (chan) {
                const parent = window.location.hostname;
                return `https://player.twitch.tv/?channel=${chan}&parent=${parent}`;
            }
        }
        if (platform === "loom" || u.hostname.includes("loom")) {
            const parts = u.pathname.split("/").filter(Boolean);
            const id = parts.pop();
            if (id) return `https://www.loom.com/embed/${id}`;
        }
    } catch { /* fall through */ }
    return null;
}

export default function EventStreamPlayer({ event }) {
    const embed = toEmbed(event.streaming_embed_url, event.streaming_platform);
    if (!event.streaming_embed_url) {
        return (
            <div
                className="aspect-video w-full rounded-2xl bg-gradient-to-br from-[#111111] to-[#111111] border border-[#1A1A1A] flex flex-col items-center justify-center gap-2"
                data-testid="event-stream-empty"
            >
                <Video size={40} className="text-neutral-500" />
                <p className="text-sm text-neutral-500">Streaming URL not yet provided</p>
            </div>
        );
    }
    if (!embed) {
        return (
            <div className="aspect-video w-full rounded-2xl bg-[#111111] border border-[#1A1A1A] flex flex-col items-center justify-center gap-2" data-testid="event-stream-fallback">
                <a
                    href={event.streaming_embed_url}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="inline-flex items-center gap-2 text-[#FFFFFF] hover:text-[#CCCCCC] font-semibold"
                >
                    Open stream <ExternalLink size={14} />
                </a>
            </div>
        );
    }
    return (
        <div className="aspect-video w-full rounded-2xl overflow-hidden border border-[#1A1A1A] bg-black" data-testid="event-stream-player">
            <iframe
                src={embed}
                title={event.title}
                className="w-full h-full"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture; encrypted-media"
                allowFullScreen
                referrerPolicy="strict-origin-when-cross-origin"
            />
        </div>
    );
}
